import * as D from '@radix-ui/react-dialog';
import type { ReactNode } from 'react';
import { t } from '../i18n/index.js';
import { fitFocused } from '../platform/keyboardFit.js';
import { Button } from './ui.js';

/** Rückfrage vor folgenreichen Aktionen (Zusammenführen, Spalte entfernen). Esc und „Abbrechen“ ändern nichts. */
export function ConfirmDialog({
  open,
  onClose,
  title,
  children,
  confirm,
  onConfirm,
  danger,
}: {
  open: boolean;
  onClose: () => void;
  title: string;
  children: ReactNode;
  confirm: string;
  onConfirm: () => void;
  danger?: boolean;
}) {
  return (
    <D.Root open={open} onOpenChange={(o) => !o && onClose()}>
      <D.Portal>
        <D.Overlay className="fixed inset-0 z-50 bg-black/30 dark:bg-black/60" />
        <D.Content
          aria-describedby={undefined}
          // F07: nie höher als die sichtbare Fläche; scrollt in sich, das fokussierte Feld bleibt über der Tastatur
          onFocusCapture={(e) => fitFocused(e.target)}
          className="fixed top-1/2 left-1/2 z-50 max-h-[calc(100dvh-32px)] w-[calc(100vw-32px)] max-w-md -translate-x-1/2 -translate-y-1/2 overflow-y-auto rounded-2xl bg-white p-4 shadow-xl outline-none dark:bg-zinc-900"
        >
          <D.Title className="text-lg font-semibold">{title}</D.Title>
          <div className="mt-3 space-y-3 text-sm text-zinc-700 dark:text-zinc-300">{children}</div>
          <div className="mt-6 flex justify-end gap-2">
            <Button variant="ghost" onClick={onClose}>
              {t('common.cancel')}
            </Button>
            <Button
              variant={danger ? 'danger' : 'primary'}
              onClick={() => {
                onConfirm();
                onClose();
              }}
            >
              {confirm}
            </Button>
          </div>
        </D.Content>
      </D.Portal>
    </D.Root>
  );
}
